<template>
  <div class="share-child-containe d-flex ml-auto">
    <button
      class="share-child-container__open-share btn btn-warning "
      @click="$refs.modal.openModal()"
      :disabled="!(childsList && childsList.length)"
    >
      Share child
    </button>
    <modal
      ref="modal"
      v-bind:title="title"
      :afterClose="modalClose"
      :customClass="'share-custom-class-modal'"
    >
      <template>
        <div class="share-child-containe-form p-3 d-flex flex-column">
          <span class="text-danger" v-if="showAlert">{{ alertText }}</span>
          <b-alert show variant="warning" class="small p-2 mb-2" v-if="showWarning">
            <p class="alert-heading font-weight-bold">Remember!</p>
            This change will not be made until approved by an administrator
          </b-alert>
          <span class="text-success" v-if="showSuccess">Share success!</span>
          <input
            type="text"
            class="form-control"
            placeholder="Parent email to share"
            v-model="parentEmail"
            :disabled="disableEmailInput"
          />
          <input
            type="text"
            class="form-control"
            placeholder="Parent name"
            v-model="parentName"
            :disabled="disableExtraInputs"
            v-if="fullDisplay"
          />
          <input
            type="text"
            class="form-control"
            placeholder="Parent last name"
            v-model="parentLastName"
            :disabled="disableExtraInputs"
            v-if="fullDisplay"
          />
          <div
            v-if="fullDisplay"
            class="share-child-containe-form__childs-list share-child-containe-childs-list mt-1"
          >
            <p class="text-muted small">Choose children to share</p>
            <div
              v-for="(child, index) in childsList"
              :key="index"
              class="share-child-containe-childs-list__child d-flex"
            >
              <label class="m-0 w-100 d-flex align-items-center" :for="`child-to-share-${index}`">
                {{ child.name }} {{ child.last_name }}
                <input
                  class="ml-auto "
                  type="checkbox"
                  value="true"
                  @change="(e) => childChange(e, child.id)"
                  :id="`child-to-share-${index}`"
                />
              </label>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-warning btn-block mt-2 w-75 mx-auto"
            @click="validateParentEmail"
            v-if="!fullDisplay"
          >
            Next
          </button>
          <div class="d-flex" v-if="fullDisplay">
            <button
              type="button"
              class="btn btn-secondary rounded-pill btn-block mt-2 w-75  mr-1"
              @click="goBack"
            >
              Back
            </button>
            <button
              type="button"
              class="btn btn-warning btn-block mt-2 w-75  ml-1"
              @click="shareChild"
            >
              Share
            </button>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import modal from '@/components/general/modal/modal.vue';
import { mapActions, mapGetters } from 'vuex';
import store from '@/store';

export default {
  props: {
    childsList: {
      required: false,
      default: [],
    },
    title: {
      type: String,
      default: 'Share',
    },
  },
  data() {
    return {
      parent: null,
      fullDisplay: false,
      disableExtraInputs: false,
      disableEmailInput: false,
      parentExist: false,
      parentEmail: '',
      parentName: '',
      parentLastName: '',
      parentCanEdit: true,
      parentToAssignId: 0,
      currentParentId: 0,
      showAlert: false,
      showWarning: false,
      showSuccess: false,
      alertText: '',
      selectedChildren: [],
    };
  },
  components: {
    modal,
  },
  computed: {
    ...mapGetters('share', ['getParentToShare']),
    getChildrenList() {
      return this.childsList;
    },
  },
  mounted() {
    this.currentParentId = store.getters['user/getUserId'];
  },
  methods: {
    ...mapActions('share', ['getParentByEmail', 'parentAssignChildren', 'parentInviteChildren']),
    validateParentEmail() {
      this.showAlert = false;
      this.showSuccess = false;
      if (this.parentEmail && this.parentEmail != '') {
        var re = /\S+@\S+\.\S+/;
        if (re.test(this.parentEmail)) {
          // to validate if parent email exist on adata base
          this.getParentByEmail(this.parentEmail).then(() => {
            // get parent info
            this.parent = this.getParentToShare;
            if (this.parent) {
              this.parentToAssignId = this.parent.id;
              // fill name and last name inputs
              this.parentName = this.parent.name;
              this.parentLastName = this.parent.last_name;
              // disable name and las name inputs
              this.disableExtraInputs = true;

              this.parentExist = true;
            } else {
              this.showWarning = true;
            }
            // show hidden inputs
            this.fullDisplay = true;
            // disable email input
            this.disableEmailInput = true;
          });
        } else {
          this.displayAlert('Invalid email');
        }
      } else {
        this.displayAlert('Email is required');
      }
    },
    goBack() {
      this.resetData();
    },
    shareChild() {
      let newSelected = [...new Set(this.selectedChildren)];
      this.showAlert = false;
      this.showWarning = false;
      if (this.parentExist) {
        this.parentAssignChildren({
          parentId: this.currentParentId,
          assignToParentId: this.parentToAssignId,
          childList: this.selectedChildren,
          canEdit: this.parentCanEdit,
        }).then((response) => {
          if (response) {
            this.resetOnSuccess();
          } else {
            this.displayAlert('Something went wrong');
          }
        });
      } else {
        this.parentInviteChildren({
          parentId: this.currentParentId,
          assignToParentId: this.parentToAssignId,
          childList: newSelected,
          canEdit: this.parentCanEdit,
          email: this.parentEmail,
          name: this.parentName,
          lastName: this.parentLastName,
        }).then((response) => {
          if (response) {
            this.resetOnSuccess();
          } else {
            this.displayAlert('Something went wrong');
          }
        });
      }
    },
    resetOnSuccess() {
      this.showSuccess = true;
      this.fullDisplay = false;
      this.disableEmailInput = false;
      this.parentEmail = '';
    },
    displayAlert(text, show = true) {
      this.showAlert = show;
      this.alertText = text;
    },
    childChange(e, id) {
      const checked = e.target.checked;
      // update chids id list
      if (checked) {
        this.selectedChildren = [...this.selectedChildren, id];
      } else {
        this.selectedChildren = this.selectedChildren.filter((chidlId) => chidlId != id);
      }
    },
    resetData() {
      this.fullDisplay = false;
      // clear inputs
      this.parentEmail = '';
      this.parentName = '';
      this.parentLastName = '';
      this.parentCanEdit = true;
      this.disableExtraInputs = false;
      this.disableEmailInput = false;
      this.selectedChildren = [];
      this.parentExist = false;
      this.showAlert = false;
      this.showWarning = false;
      this.showSuccess = false;
    },
    modalClose() {
      this.resetData();
    },
  },
};
</script>

<style>
.share-custom-class-modal .modal-content {
  width: 100% !important;
}
.share-child-containe .share-child-container__open-share {
  max-width: 200px;
}
.share-child-containe .share-child-containe-form {
  row-gap: 0.5rem;
  width: 100%;
  max-width: 100%;
}
.share-child-containe .share-child-containe-childs-list {
  /*border: 1px solid rgba(0,0,0,.2);*/
  border-radius: 0.25rem;
  padding: 0.2rem;
}
.share-child-containe .share-child-containe-childs-list__child {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.25rem;
}
.share-child-containe .share-child-containe-childs-list__child label {
  padding: 0.375rem 0.75rem;
  cursor: pointer;
}
@media (min-width: 576px) {
  .share-custom-class-modal .modal-content {
    width: 300px !important;
  }
  .share-child-containe .share-child-containe-form {
    width: 300px;
    max-width: 300px;
  }
}
</style>

<style scoped>
.text-warning,
.text-danger,
.text-success {
  font-size: 16px;
}
.share-child-containe-form {
  max-height: 80vh;
}
.share-child-containe-form__childs-list {
  overflow-y: auto;
}
</style>
